import { getBankDepositListApi } from "apis";
import { DataTableV2, Intro } from "components/commons";
import { StationContext } from "contexts";
import { FormMode, Path } from "enums";
import { useAlert, useRouter } from "hooks";
import useDataTable from "hooks/useDataTable";
import locale from "localization";
import { useContext, useState } from "react";
import { bankDepositColumns } from "./bank-deposit-list-column";
import { mapDataToList, mapFilterToRequest } from "./bank-deposit-list-mapper";
import { initialFilterState } from "./bank-deposit-filter.state";
import BankDepositFilter from "./bank-deposit-filter";
import { ImagePreview } from "components/modals";
const BankDepositModule = () => {
  const { station } = useContext(StationContext);
  const router = useRouter();
  const { addAlert } = useAlert();
  const [imageUrl, setImageUrl] = useState("");
  const { filter, table, search } = useDataTable({
    api: {
      api: getBankDepositListApi,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateType: true,
      },
    },
    table: {
      key: "bankDeposits",
      mapper: (bankDeposits) =>
        mapDataToList({
          bankDeposits,
          onClickViewSlip: (imageUrl) => {
            if (!imageUrl) {
              return addAlert({
                title: "Oops! No Image to Show",
                subtitle: "This image isn't available right now. Please check back later.",
                type: "error",
                interval: 3000,
              });
            }
            setImageUrl(imageUrl);
          },
          onClickView: (bankDepositId) => {
            router.push(Path.ViewBankDepositDetails(bankDepositId, FormMode.View));
          },
          imageUrl,
        }),
      columns: bankDepositColumns,
    },
  });

  return (
    <div>
      <Intro title={locale.bankDepositLogs} />
      <BankDepositFilter {...filter} {...search} />
      <DataTableV2 {...table} />
      <ImagePreview value={imageUrl} onClose={() => setImageUrl("")} />
    </div>
  );
};

export default BankDepositModule;
